import { LiveAdBrandData } from '@moojo/ad-delivery-api'
import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const ConvoAdDetails = z.object({
  servingUrl: z.string(),
  brandName: z.string(),
  headline: z.string(),
  subHeadline: z.string(),
  launcherText: z.string(),
  widgetHeaderText: z.string(),
  placeholderText: z.string(),
  guardrails: z.string(),
  followupMessage: z.string(),
  quickActions: z.object({ code: z.string(), text: z.string() }).array(),
  productFeedSlug: z.string().optional(),
  brand: LiveAdBrandData,
  pageTopic: z.string().optional(),
})

export type ConvoAdDetails = z.infer<typeof ConvoAdDetails>

export const RecommendConvoAdRequest = z.object({
  /* All info is passed in query string */
})

export type RecommendConvoAdRequest = z.infer<typeof RecommendConvoAdRequest>

export const RecommendConvoAdResponse = z.discriminatedUnion('match', [
  z.object({
    match: z.literal(true),
    adDetails: ConvoAdDetails,
    voiceflowSettings: z.object({ projectId: z.string(), side: z.union([z.literal('left'), z.literal('right')]) }),
  }),
  z.object({ match: z.literal(false), message: z.string() }),
])

export type RecommendConvoAdResponse = z.infer<typeof RecommendConvoAdResponse>

export const recommendConvoAdDeclaration = endpointDeclaration(RecommendConvoAdRequest, RecommendConvoAdResponse)

export const RecommendConvoAdRequestQueryParams = z.object({
  location: z.string(),
  lang: z.string().optional(),
  /**
   * Allows the caller to request a specific ad. We intentionally do not restrict it to be UUID by passing any string
   * here it will also trigger additional logging which can be useful on its own.
   */
  adId: z.string().optional(),
})

export type RecommendConvoAdRequestQueryParams = z.infer<typeof RecommendConvoAdRequestQueryParams>
